import parsePhoneNumber from 'libphonenumber-js';

export function assertOptional(value) {
  return [null, undefined, ''].includes(value);
}

export function assertRequired(value) {
  return !assertOptional(value);
}

export function assertPhoneNumber(value, defaultCountry = 'US') {
  const phoneNumber = parsePhoneNumber(value, { defaultCountry });
  return !!phoneNumber && phoneNumber.isValid();
}

const emailRegex = "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$";

export function assertEmail(value) {
  return new RegExp(emailRegex).test(String(value).toLowerCase());
}
